export default "__VITE_ASSET__7h5bYynG__"